import React from 'react';
import { Box, Button, CircularProgress, Divider } from '@mui/material';

interface WizardFooterProps {
  onBack?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextType?: 'button' | 'submit';
  onNext?: () => void;
  isSubmitting?: boolean;
}

const WizardFooter: React.FC<WizardFooterProps> = ({
  onBack,
  nextLabel = 'Weiter →',
  nextDisabled = false,
  nextType = 'button',
  onNext,
  isSubmitting = false,
}) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Divider sx={{ mb: 3 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        {onBack ? (
          <Button
            variant="outlined"
            color="inherit"
            size="large"
            onClick={onBack}
            sx={{
              borderColor: 'divider',
              color: 'text.primary',
              fontWeight: 700,
              px: 3,
              bgcolor: '#fff',
              '&:hover': { bgcolor: 'grey.50', borderColor: 'grey.400' },
            }}
          >
            ← Zurück
          </Button>
        ) : (
          <Box />
        )}
        <Button
          variant="contained"
          size="large"
          type={nextType}
          onClick={onNext}
          disabled={nextDisabled || isSubmitting}
          sx={{ fontWeight: 700, px: 3.5 }}
        >
          {isSubmitting ? <CircularProgress size={24} color="inherit" /> : nextLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default WizardFooter;
